import React from "react";
import PropTypes from "prop-types";
// import { withStyles } from "@material-ui/core/styles";
import Snackbar from "@material-ui/core/Snackbar";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";

const AnnotationSnackbar = props => {
  const filesList = props.successfulAnnotations.map((x, i) => {
    if (props.successfulAnnotations.length - 1 === i) return <span>{x}</span>;
    return (
      <span>
        {x}
        <br />
      </span>
    );
  });
  const fileNum = ` ${props.successfulAnnotations.length} `;
  return (
    <Snackbar
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "left"
      }}
      open={props.annotationSnackbarOpen}
      autoHideDuration={15000}
      onClose={props.onAnnotationSnackbarClose}
      ContentProps={{
        "aria-describedby": "message-id"
      }}
      message={
        <span id="message-id">
          You successfully annotated
          {fileNum}
          file(s):
          <br />
          {filesList}
        </span>
      }
      action={[
        <IconButton
          key="close"
          aria-label="Close"
          color="inherit"
          // className={classes.close}
          onClick={props.onAnnotationSnackbarClose}
        >
          <CloseIcon />
        </IconButton>
      ]}
    />
  );
};

AnnotationSnackbar.propTypes = {
  annotationSnackbarOpen: PropTypes.bool.isRequired,
  onAnnotationSnackbarClose: PropTypes.func.isRequired,
  successfulAnnotations: PropTypes.arrayOf(PropTypes.string)
};

AnnotationSnackbar.defaultProps = {
  successfulAnnotations: []
};

export default AnnotationSnackbar;
